import {Component, OnInit, Inject, OnDestroy} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CODE_WORKFLOW_COMPONENT, Model_WorkflowComponent, TYPE_DEFAULT_VALUE, Model_VariableEnvironnement, FORMAT_NUMBER, TYPE_COMPONENT_CONDITIONS, FONCTION_WORKFLOW_COMPONENT_OPTIONS } from 'src/app/app.models';
import { FormBuilder, Validators } from '@angular/forms';
import { WorkflowComponentsService } from '../../workflow-components.service';
import { Subject } from 'rxjs';
import { DatasourcePickerModel } from '../../datasource-picker/datasource-picker.model';
import { RichAutocompleteModel } from '../../rich-autocomplete/rich-autocomplete.model';
import { COMPONENT_MODE } from '../../workflow-components.models';
import { WorkflowRulesBuilderComponent } from 'src/app/pages/views/settings/workflow/workflow-rules-builder/workflow-rules-builder.component';

@Component({
    selector: 'app-input-grid-columns-builder-dialog',
    templateUrl: './input-grid-columns-builder-dialog.component.html',
    styleUrls: ['./input-grid-columns-builder-dialog.component.scss']
})
export class InputGridColumnsBuilderDialogComponent implements OnInit, OnDestroy {
    selectedColumnIndex = -1;
    selectedColumn: any = {};
    columns: any[] = [];
    gridColumns: any[] = [];
    columnFormGroup = this._formBuilder.group({
        CODE: [null, Validators.required],
        INDEX: [null, Validators.required],
        ID: [null, Validators.required],
        LABEL: [null, Validators.required],
        IS_READONLY: [false],
        IS_VISIBLE: [true],
        NUMBER_FORMAT: [null],
        HAS_DATASOURCE: [null],
        NUM_DATASOURCE: [null],
        VALUE_COLUMN_NAME: [null],
        DISPLAY_COLUMN_NAME: [null],
        TYPE_DEFAULT_VALUE: [TYPE_DEFAULT_VALUE.CONSTANT, Validators.required],
        TYPE_DEFAULT_VALUE_FUNCTION_ID: [null],
        DEFAULT_VALUE: [null],
        DEFAULT_VALUE_EXPRESSION: [null],
        DEFAULT_VALUE_WORKFLOW_COMPONENT_ID: [null],
        DEFAULT_VALUE_WORKFLOW_COMPONENT_PROPERTY: [null],
        CONDITIONS_ENABLED: [null],
        DATE_FORMAT: ['DD/MM/YYYY']
    });
    allowedComponents: Model_WorkflowComponent[] = [];
    selectedComponent = new Model_WorkflowComponent();
    datasourcePickerModel: DatasourcePickerModel;
    datasourceAvailableColumns: { value: any, display: string }[] = [];
    typeValeurs = [
        { ID: TYPE_DEFAULT_VALUE.CONSTANT, TEXT: 'Constante' }, 
        { ID: TYPE_DEFAULT_VALUE.COMPUTED, TEXT: 'Calculé' },
        { ID: TYPE_DEFAULT_VALUE.ENVIRONMENT_VARIABLE, TEXT: 'Variable d\'environnement' },
        { ID: TYPE_DEFAULT_VALUE.WORKFLOW_FIELD, TEXT: 'Champ du workflow' },
        { ID: TYPE_DEFAULT_VALUE.WORKFLOW_GRID_FIELD, TEXT: 'Champ de la grille' },
        { ID: TYPE_DEFAULT_VALUE.FONCTION, TEXT: 'Fonction' },
    ];
    onComplete = new Subject();
    autocompleteModel: RichAutocompleteModel;
    variablesEnvironnement: Model_VariableEnvironnement[] = [];
    selectedDatasource: any = null;
    FORMAT_NUMBER = FORMAT_NUMBER;
    CODE_WORKFLOW_COMPONENT = CODE_WORKFLOW_COMPONENT;
    TYPE_DEFAULT_VALUE = TYPE_DEFAULT_VALUE;
    TYPE_COMPONENT_CONDITIONS = TYPE_COMPONENT_CONDITIONS;
    FONCTION_WORKFLOW_COMPONENT_OPTIONS = FONCTION_WORKFLOW_COMPONENT_OPTIONS;

    constructor(
        public dialogRef: MatDialogRef<InputGridColumnsBuilderDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private _formBuilder: FormBuilder,
        private _dialog: MatDialog,
    ) {
        this.variablesEnvironnement = data.variablesEnvironnement;
        this.allowedComponents = data.allowedComponents;
        this.selectedColumnIndex = data.selectedColumnIndex;
        this.selectedColumn = data.selectedColumn;
        this.columns = data.columns;
        this.gridColumns = data.gridColumns;
        this.columnFormGroup.patchValue({
            CODE: this.selectedColumn.CODE,
            INDEX: this.selectedColumnIndex + 1,
            ID: this.selectedColumn.ID,
            LABEL: this.selectedColumn.LABEL,
            NUMBER_FORMAT: this.selectedColumn.NUMBER_FORMAT,
            IS_VISIBLE: this.selectedColumn.IS_VISIBLE !== undefined ? this.selectedColumn.IS_VISIBLE : true,
            IS_READONLY: this.selectedColumn.IS_READONLY,
            HAS_DATASOURCE: this.selectedColumn.HAS_DATASOURCE,
            NUM_DATASOURCE: this.selectedColumn.NUM_DATASOURCE,
            VALUE_COLUMN_NAME: this.selectedColumn.VALUE_COLUMN_NAME,
            DISPLAY_COLUMN_NAME: this.selectedColumn.DISPLAY_COLUMN_NAME,
            TYPE_DEFAULT_VALUE: !!this.selectedColumn.TYPE_DEFAULT_VALUE ? this.selectedColumn.TYPE_DEFAULT_VALUE : TYPE_DEFAULT_VALUE.CONSTANT,
            TYPE_DEFAULT_VALUE_FUNCTION_ID: this.selectedColumn.TYPE_DEFAULT_VALUE_FUNCTION_ID,
            DEFAULT_VALUE: this.selectedColumn.DEFAULT_VALUE,
            DEFAULT_VALUE_EXPRESSION: this.selectedColumn.DEFAULT_VALUE_EXPRESSION,
            DEFAULT_VALUE_WORKFLOW_COMPONENT_ID: this.selectedColumn.DEFAULT_VALUE_WORKFLOW_COMPONENT_ID,
            DEFAULT_VALUE_WORKFLOW_COMPONENT_PROPERTY: this.selectedColumn.DEFAULT_VALUE_WORKFLOW_COMPONENT_PROPERTY,
            CONDITIONS_ENABLED: this.selectedColumn.CONDITIONS_ENABLED,
            DATE_FORMAT: this.selectedColumn.DATE_FORMAT || 'DD/MM/YYYY',
        });
        this.onSelectedComponent(this.selectedColumn.CODE);
        if (!!this.selectedColumn.NUM_DATASOURCE) {
            this.onDatasourceSelected(this.selectedColumn.NUM_DATASOURCE);
        }
        this.autocompleteModel = RichAutocompleteModel.initModel({
            ID: 'DEFAULT_VALUE_EXPRESSION',
            CODE: CODE_WORKFLOW_COMPONENT.RICH_AUTOCOMPLETE,
            LABEL: 'Expression à évaluer',
            DEFAULT_VALUE: '',
            IS_REQUIRED: true,
            IS_READONLY: false,
            CUSTOM_VALIDATORS: [],
            COMPONENT_MODE: COMPONENT_MODE.EXECUTION,
            RELATIONS: [],
            workflowComponents: this.columns,
            variablesEnvironnement: [],
            typeInput: CODE_WORKFLOW_COMPONENT.TEXTBOX,
        });
        this.onWorkflowComponentSelected(this.columnFormGroup.controls.DEFAULT_VALUE_WORKFLOW_COMPONENT_ID.value);
        this.datasourcePickerModel = DatasourcePickerModel.initModel({ 
            ID: 'GRID_COLUMN_NUM_DATASOURCE', 
            CODE: CODE_WORKFLOW_COMPONENT.DATASOURCE_PICKER, 
            LABEL: 'Source de données', 
            IS_REQUIRED: true,
            workflowComponents: data.columns, 
            gridComponents: data.gridColumns, 
        });
    } 
    
    async ngOnInit() {
    }

    ngOnDestroy() {
        this.onComplete.next();
        this.onComplete.complete();
    }

    onDatasourceSelected(_datasource: any) {
        if (!_datasource) { return; }
        this.columnFormGroup.controls.HAS_DATASOURCE.patchValue(true);
        this.columnFormGroup.controls.NUM_DATASOURCE.patchValue(_datasource);
        this.datasourceAvailableColumns = _datasource.DS_COLUMNS.map(c => ({ value: c.name, display: c.name}));
    }

    onSelectedComponent(_value: string) {
        this.selectedComponent = this.allowedComponents.find(c => c.CODE === _value);
    }

    dismiss(): void {
        this.dialogRef.close();
    }

    onSubmit() {
        if (this.columnFormGroup.invalid) { return; }
        this.dialogRef.close({ columnIndex: this.selectedColumnIndex, column: this.columnFormGroup.value });
    }

    onWorkflowComponentSelected(_columnID: any) {
        this.selectedDatasource = null;
        const columnSelected = this.columns.find(c => c.ID == _columnID);
        if (!columnSelected) { return; }
        const basedComponent = this.allowedComponents.find(comp => comp.CODE == columnSelected.CODE);
        if (!basedComponent || !basedComponent.PROPERTIES) { return; }
        if(columnSelected.HAS_DATASOURCE === true && !!columnSelected.NUM_DATASOURCE && !!columnSelected.NUM_DATASOURCE.NUM_DATASOURCE) {
            this.selectedDatasource = columnSelected.NUM_DATASOURCE;
        }
    }

    onGridColumnSelected(_columnID: string) {
        this.selectedDatasource = null;
        const columnSelected = this.gridColumns.find(c => c.ID == _columnID);
        if (!columnSelected) { return; }
        const basedComponent = this.allowedComponents.find(comp => comp.CODE == columnSelected.CODE);
        if (!basedComponent || !basedComponent.PROPERTIES) { return; }
        if(columnSelected.HAS_DATASOURCE === true && !!columnSelected.NUM_DATASOURCE && !!columnSelected.NUM_DATASOURCE.NUM_DATASOURCE) {
            this.selectedDatasource = columnSelected.NUM_DATASOURCE;
        }
    }

    openRulesBuilderDialog(_typeConditions: TYPE_COMPONENT_CONDITIONS) {
        let oldConditions = null;
        if (_typeConditions == TYPE_COMPONENT_CONDITIONS.CONDITION_ENABLED) {
            oldConditions = this.columnFormGroup.controls.CONDITIONS_ENABLED.value || null;
        }
        const dialogRef = this._dialog.open(WorkflowRulesBuilderComponent, {
            data: {
                components: this.gridColumns,
                variables: [],
                datasources: [],
                typeConditions: _typeConditions,
                conditions: oldConditions
            },
            width: '95vw',
            panelClass: 'datasource-designer-modal'
        });
      
        dialogRef.afterClosed().subscribe((_result?: any) => {
            if (!_result) { return; }
            if (_typeConditions == TYPE_COMPONENT_CONDITIONS.CONDITION_ENABLED) {
                this.columnFormGroup.controls.CONDITIONS_ENABLED.patchValue(_result);
            }
        });
    }

    countComponentConditions(_typeConditions: TYPE_COMPONENT_CONDITIONS) {
        let count = 0;
        if (_typeConditions == TYPE_COMPONENT_CONDITIONS.CONDITION_ENABLED) {
            const conditions = this.columnFormGroup.controls.CONDITIONS_ENABLED.value;
            if (!!conditions && !!conditions.rules) {
                count = conditions.rules.length;
            }
        }
        return count;
    }
}